module.exports = __webpack_public_path__ + "images/emoji/triangular_flag_on_post.9a901f3a4a5806d6d893.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/triangular_flag_on_post.png
// module id = 4Gyl
// module chunks = 24